import React, { useEffect, useMemo, useState } from 'react'
import {
    Form,
    Input,
    Button,
    Switch,
    Row,
    Col,
    Space,
    DatePicker,
    Select,
    type DatePickerProps,
    Tooltip,
} from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import commonStyles from '../../../../../../Utils/Common.less'
import {
    type PayeEditpageProps,
    type TogilleAddress,
} from '../../../../../../Types/Client/RegisteredClients/Partnership'
import { connect, useDispatch } from 'react-redux'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'
import {
    GetCountryList,
    GetPayeProcessData,
} from '../../../../../../Services/Common'
import moment from 'moment'
import dayjs from 'dayjs'
import { GetAddress, PayeSaveData } from '../../../../../../Services/Parnership'
// import { validateDate } from '../../../../../../Utils/ValidateDate'
import { type PayeStateInterface } from '../../../../../../Types/Client/RegisteredClients/Corporate'
import PostCodeInput from '../../../../../../Components/PostCodeInput'
import { getValidationRules } from '../../../../../../Utils/validatefiled'
const { Option } = Select

const PayeEditForm = (props: PayeEditpageProps): React.ReactElement => {
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [servicesEnabled, setServicesEnabled] = useState(false)
    const [CISFillingEnabled, setCISFillingEnabled] = useState(false)
    const [schemeStartDate, setschemeStartDate] = useState<string>('')
    const {
        PayeeditData,
        handleChildFormSave,
        partnershipId,
        countryList,
        payeProcessList,
    } = props

    const [switchStates, setSwitchStates] = useState<{
        1: boolean
        2: boolean
        3: boolean
    }>({
        1: false,
        2: false,
        3: false,
    })
    const [addressDatas, setAddressData] = useState<TogilleAddress | null>(null)
    const [buttonloading, setButtonLoading] = useState(false)
    const [payrollFrequencyid, setPayRolleFeqency] = useState('')
    const [payeProcessId, setPayeProcessId] = useState(0)
    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            const AddressData = {
                town: address.post_town,
                country: countryData?.label ?? '',
                postCode: address.postcode,
                addressLineOne: address?.line_1,
                addressLineTwo: address?.line_2,
            }
            form.setFieldsValue(AddressData)
        }
    }, [address])

    useEffect(() => {
        GetCountryList(dispatch)
        GetPayeProcessData(dispatch)
    }, [dispatch])

    useEffect(() => {
        if (countryList !== null && PayeeditData !== null) {
            const countryData = countryList.find(
                (data: ListFrontEndInterface) =>
                    data.label === PayeeditData.country
            )
            const newData = {
                ...PayeeditData,
                country: countryData?.label ?? 'Please Select',
            }
            form.setFieldsValue(newData)
            setServicesEnabled(PayeeditData.status === 'Active')
            setCISFillingEnabled(PayeeditData.csiFiling === 1)
        }
    }, [PayeeditData, countryList])

    const handleServiceSwitchChange = (checked: boolean): void => {
        setServicesEnabled(checked)
    }

    const handleCISFillingChange = (checked: boolean): void => {
        setCISFillingEnabled(checked)
    }
    useEffect(() => {
        form.setFieldsValue(PayeeditData)
        if (PayeeditData !== null) {
            const SchemeStartDate = moment(
                PayeeditData.schemeStartDate,
                'M/D/YYYY h:mm:ss A'
            )
            const formastartdate = SchemeStartDate.format('MM/DD/YYYY')
            setschemeStartDate(formastartdate)
        }
    }, [PayeeditData])

    useEffect(() => {
        form.setFieldValue('schemeStartDate', schemeStartDate)
    }, [schemeStartDate])

    const onChangeStartDate = (
        deadlineDate: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (deadlineDate != null) {
            const isoDate = deadlineDate.toISOString()
            setschemeStartDate(isoDate)
            form.setFieldValue('schemeStartDate', isoDate)
            void form.validateFields(['schemeStartDate'])
        }
    }

    const handleSwitchChange = (switchId: 1 | 2 | 3): void => {
        const newSwitchStates = {
            1: false,
            2: false,
            3: false,
        }
        if (!switchStates[switchId]) {
            newSwitchStates[switchId] = true
            void GetAddress(
                dispatch,
                partnershipId,
                switchId,
                (addressData: TogilleAddress) => {
                    setAddressData(addressData)
                }
            )
        } else {
            form.setFieldsValue({
                addressLineOne: '',
                addressLineTwo: '',
                town: '',
                country: '',
                postCode: '',
            })
        }
        setSwitchStates(newSwitchStates)
    }

    useEffect(() => {
        if (addressDatas !== null && typeof addressDatas === 'object') {
            const newFieldValues = {
                addressLineOne: addressDatas?.addressLineOne,
                addressLineTwo: addressDatas?.addressLineTwo,
                town: addressDatas?.town,
                country: addressDatas?.country,
                postCode: addressDatas?.postCode,
            }

            form.setFieldsValue(newFieldValues)
        }
    }, [addressDatas])

    const handleSave = (): void => {
        void handleSaveData()
    }
    const handleSaveData = async (): Promise<void> => {
        try {
            await form.validateFields()
            setButtonLoading(true)
            const formData = form.getFieldsValue()

            const filingMethodName = formData.filingMethodName
            let filingMethod: number
            if (filingMethodName === 'Nil Return') {
                filingMethod = 1
            } else if (filingMethodName === 'Standard Filing') {
                filingMethod = 2
            } else if (
                filingMethodName === 'Hours to be obtained WEEKLY Filing'
            ) {
                filingMethod = 3
            } else {
                filingMethod = 0
            }

            const dataToSave = {
                payeId: PayeeditData.payeId,
                companyType: 4,
                referenceId: partnershipId,
                payeReference: formData.payeReference,
                accountOfficeReference: formData.accountOfficeReference,
                payrollFrequency: formData.payrollFrequency,
                schemeStartDate: moment(formData.schemeStartDate).format(
                    'DD/MM/YYYY'
                ),
                addressLineOne: formData.addressLineOne,
                addressLineTwo: formData.addressLineTwo,
                town: formData.town,
                country: formData.country,
                postCode: formData.postCode,
                gateWayId: formData.gateWayId,
                password: formData.password,
                status: servicesEnabled ? 'Active' : 'Inactive',
                csiFiling: CISFillingEnabled ? 1 : 0,
                payeProcess: payeProcessId,
                filingMethod: filingMethod ?? 0,
                payeProcessName: PayeeditData.payeProcessName,
                filingMethodName: formData.afilingMethodName,
                hmrcPaymentFrequency: PayeeditData.hmrcPaymentFrequency,
                hmrcPaymentFrequencyName: PayeeditData.hmrcPaymentFrequencyName,
            }
            await PayeSaveData(dispatch, dataToSave).then((result) => {
                if (result !== null && result !== undefined) {
                    handleChildFormSave()
                    setButtonLoading(false)
                }
            })
        } catch (error) {}
    }

    const handelpayrollFrequencyChange = (value: string): void => {
        setPayRolleFeqency(value)
    }

    const hanldePayeProcessIdchange = (value: number): void => {
        setPayeProcessId(value)
    }
    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    const rules = useMemo(
        () => getValidationRules(servicesEnabled),
        [servicesEnabled]
    )
    return (
        <div className={commonStyles.formWrapper}>
            <Form
                form={form}
                name="ct-form"
                layout={'vertical'}
                autoComplete="off"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                requiredMark={customizeRequiredMark}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Same as Business"
                            name="businessSwitch"
                            labelCol={{ span: 16 }}
                            wrapperCol={{ span: 8 }}
                        >
                            <Switch
                                id="2"
                                checked={switchStates[2]}
                                onChange={() => {
                                    handleSwitchChange(2)
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Same as Correspondence"
                            name="correspondenceSwitch"
                            labelCol={{ span: 16 }}
                            wrapperCol={{ span: 8 }}
                        >
                            <Switch
                                id="3"
                                checked={switchStates[3]}
                                onChange={() => {
                                    handleSwitchChange(3)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="PAYE Reference"
                            rules={rules.payeReference}
                            name="payeReference"
                        >
                            <Input allowClear maxLength={15} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="addressLineTwo" label="Address 2">
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Account Office Reference"
                            name="accountOfficeReference"
                            rules={rules.accountOfficeReference}
                        >
                            <Input allowClear maxLength={15} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Town " name="town" rules={rules.town}>
                            <Input allowClear maxLength={50} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Payroll Frequency"
                            name="payrollFrequency"
                        >
                            <Select
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    typeof option?.children === 'string' && // Ensure option.children is a string
                                    (option.children as string)
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                    handelpayrollFrequencyChange(value)
                                }}
                            >
                                <Option value="WEEKLY">WEEKLY</Option>
                                <Option value="BI WEEKLY">BI WEEKLY</Option>
                                <Option value="FOUR WEEKLY">FOUR WEEKLY</Option>
                                <Option value="MONTHLY">MONTHLY</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Country " name="country">
                            <Select
                                allowClear
                                placeholder="Please select"
                                showSearch
                                onChange={() => {}}
                                options={countryList?.map((country) => ({
                                    value: country.label,
                                    label: country.label,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Scheme Start Date"
                            name="schemeStartDate"
                            rules={rules.schemeStartDate}
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    className={commonStyles.dateWidth}
                                    onChange={(date, dateString) => {
                                        form.setFieldsValue({
                                            schemeStartDate: date,
                                        })
                                        void form.validateFields([
                                            'schemeStartDate',
                                        ])
                                        onChangeStartDate(date, dateString)
                                    }}
                                    value={
                                        schemeStartDate.length > 0
                                            ? dayjs(schemeStartDate)
                                            : null
                                    }
                                    format="DD/MM/YYYY"
                                    allowClear
                                />
                            </Space>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <PostCodeInput
                            name="postCode"
                            label="Post Code"
                            reuireMessage="Please Enter Post Code"
                            placeHolder={''}
                            setAddressDetails={setAddress}
                            require={servicesEnabled}
                        />
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Address 1"
                            name="addressLineOne"
                            rules={rules.addressLineOne}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="HMRC Gateway ID"
                            name="gateWayId"
                            rules={[
                                {
                                    pattern: /^[a-zA-Z0-9]*$/,
                                    message:
                                        'Only alphanumeric characters are allowed',
                                },
                                {
                                    max: 12,
                                    message: 'Maximum length is 12 characters',
                                },
                            ]}
                        >
                            <Input allowClear maxLength={12} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="CIS Filing" name="csiFiling">
                            <Switch
                                onChange={handleCISFillingChange}
                                checked={CISFillingEnabled}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[
                                {
                                    min: 8,
                                    message:
                                        'Password must be at least 8 characters long!',
                                },
                            ]}
                        >
                            <Input allowClear minLength={8} />
                        </Form.Item>
                    </Col>
                </Row>
                {payrollFrequencyid === 'MONTHLY' && (
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Paye Process Date"
                                name="payeProcess"
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Please select"
                                    onChange={(value) => {
                                        hanldePayeProcessIdchange(value)
                                    }}
                                    options={[
                                        { label: 'Please select', value: 0 },
                                        ...payeProcessList?.map(
                                            (
                                                service: ListFrontEndInterface
                                            ) => ({
                                                value: service.value,
                                                label: service.label,
                                            })
                                        ),
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                )}
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Enable/Disable Services"
                            labelCol={{ span: 16 }}
                            wrapperCol={{ span: 8 }}
                        >
                            <Switch
                                onChange={handleServiceSwitchChange}
                                checked={servicesEnabled}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Filing Method"
                            name="filingMethodName"
                        >
                            <Select
                                allowClear
                                placeholder="Please select"
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    typeof option?.children === 'string' && // Ensure option.children is a string
                                    (option.children as string)
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                <Option value="Nil Return">Nil Return</Option>
                                <Option value="Standard Filing">
                                    Standard Filing
                                </Option>
                                <Option value="Hours to be obtained WEEKLY">
                                    Hours to be obtained WEEKLY
                                </Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col offset={21} span={2}>
                        <Tooltip title="Save PAYE Service">
                            <Button
                                type="primary"
                                onClick={handleSave}
                                loading={buttonloading}
                            >
                                <SaveOutlined />
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}
const mapStateToProps = (state: any): PayeStateInterface => {
    return {
        countryList: state.common.countryList,
        payeProcessList: state.common.payeProcessList,
    }
}
export default connect(mapStateToProps)(PayeEditForm)
